import loadable from '@loadable/component';

export const JoinOtaLegalShortLoadable = loadable(() => import('./JoinOtaLegalShort'), {
  fallback: null,
  ssr: false,
});
